<template>
    <!-- 팝업_GA 데이터 활용 안내 약관 S : 2020.02.26 Add 홍병기K -->
    <div id="popupGA" class="popup-wrap" hidden>
        <div class="popup popup-type1 popup-ga" role="dialog" aria-labelledby="popupGATitle">
            <div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.ga.pop.label.001')"></div>
            <div class="popup-container">
                <div class="popup-header">
                    <h3 class="tit-h3" id="popupGATitle">{{ $t('sdp.menu.ga.pop.message.001') }}</h3>
                </div>
                <div class="popup-body popup-scroll">
                    <div class="para-wrap">
                        <div class="gaTermsContent">
                            <ul>
                                <li v-html="$t('sdp.menu.ga.pop.message.003')"></li>
                                <li v-html="$t('sdp.menu.ga.pop.message.004')"></li>
                                <li v-html="$t('sdp.menu.ga.pop.message.005')"></li>
                                <li v-html="$t('sdp.menu.ga.pop.message.006')"></li>
                                <li v-html="$t('sdp.menu.ga.pop.message.007')"></li>
                                <li>{{ $t('sdp.menu.ga.pop.message.008') }}<br><span v-html="$t('sdp.menu.ga.pop.message.009')"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="popup-footer">
                    <div class="btn-wrap">
                        <button type="button" @click="closeGADimmer()" class="btn btn-type2 popup-close btn-primary" aria-controls="popupGA" :title="$t('gwa.alt.ga.pop.title.001')"><span>{{ $t('sdp.menu.ga.pop.message.002') }}</span></button>
                    </div>
                </div>
                <button type="button" @click="closeGADimmer()" class="btn-ico btn-popup-close popup-close" aria-controls="popupGA" :aria-label="$t('gwa.alt.ga.pop.label.002')" title=""><span><i class="ico ico-close2"></i></span></button>
            </div>
        </div>
    </div>
    <!-- //팝업_GA 데이터 활용 안내 약관 E : 2020.02.26 Add 홍병기K -->
</template>

<script>
    export default {
        name: "GAPop",
        data() {
            return {
                cntryCode: _domainCntryCode
            }
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
            closeGADimmer() {
                ui.popup.close("popupGA");
                ui.popup.init();
            }
        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode == 27) {
                    ui.popup.close("popupGA");
                    ui.popup.init();
                }
            });
        }
    }
</script>

<style scoped>

</style>